// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".facility-detail-modal[data-v-1588b274]  .facility .facility-image{width:435px;max-width:435px;min-width:435px}.facility-detail-modal[data-v-1588b274]  .facility .facility-basic-info .facility-name{font-size:20px;font-weight:700}.facility-detail-modal[data-v-1588b274]  .facility .cancel-btn{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
